import { FORMS_REDUCER } from '../constants';
import { useCustomSelector } from './useCustomSelector';

import { TFormsSelector, TEqualityFunction } from '../types';

export const useFormsSelector = <TSelected>(selector: TFormsSelector<TSelected>, equalityFn?: TEqualityFunction<TSelected>) => {
    return useCustomSelector<TSelected, typeof FORMS_REDUCER>(FORMS_REDUCER, selector, equalityFn);
};
